import { render, staticRenderFns } from "./budget-details.vue?vue&type=template&id=8fec2dd2&scoped=true&"
import script from "./budget-details.vue?vue&type=script&lang=js&"
export * from "./budget-details.vue?vue&type=script&lang=js&"
import style0 from "./budget-details.vue?vue&type=style&index=0&id=8fec2dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fec2dd2",
  null
  
)

export default component.exports